import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { Preferences } from '../../profile/objects/preferences';
import { DEFAULT_COLUMN, SETTLEMENT_MODULE } from '../constant/settlementConstant';
import { Column } from '../objects/column';

export const setSettlementPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: SETTLEMENT_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});
